<template>

 
  <!-- Modal -->
  <div class="modal fade" id="exampleModal46" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="card">
          <div class="modal-header" style="border-bottom: 1px solid rgba(250,250, 250, 0.4);">
            <h5 class="modal-title" id="exampleModalLabel"></h5>
            <button type="button" @click="close" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" style="margin-top:40px; margin-bottom: 60px;">
            <div class="text text-center">
              <h5>{{ $t("import_student.title_modal") }}</h5>
              <p class="mt-4">{{ $t("import_student.text_modal") }}</p>
              <div class="mt-4 p-0 mx-auto" style="width:600px">
                <div class="d-flex" style="justify-content: space-between;">
                  <div class="">
                    <button class="generate" @click="showgenerate">
                      <span style="color: white; font-weight: 600;">{{ $t("import_student.btn1") }}</span>
                    </button>
                  </div>
                  <div class="ms-4">
                    <button class="generate" @click="generateSampleAndClose">
                      <span style="color: white; font-weight: 600;">{{ $t("import_student.btn2") }}</span>
                    </button>
                  </div>
                </div>

                <div class="mx-auto text-start p-0 mt-4" style="width:600px;" v-if="show_generate">
                  <label for="student-count">{{ $t("import_student.label") }}<em style="color: #f60000">*</em></label>
                  <div class="input-group w-100 mb-3">
                    <input id="student-count" type="number" v-model="count" class="form-control" style="height: 50px"
                      :placeholder="$t('import_student.placeholder')" :class="{
                        required: requiredFields.count,
                        'required-thick': requiredFields.count,
                      }" />
                      <button class="btn bg-success text-light fw-bold generate-registration-number"
                              @click="fetchAndDownloadRegistrationNumbers()"
                              type="button">
                        {{ $t("new_student.gendered") }}
                      </button>
                  </div>
                </div>

                <div class="d-flex ms-2" v-if="show_generate && downloadLink && !isGenerating"
                  style="margin-top: -25px;">
                  <p class="mt-2">  {{ $t("import_student.text_upload") }}</p>
                  <button class="btn mx-3" style="background: #75acff;" :title="$t('import_student.title_download')"
                    @click.prevent="downloadGeneratedFile">
                    <i style="color:white;" class="fa fa-download"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="border-top: 1px solid rgba(250,250, 250, 0.5);">
            <argon-button type="button" class="btn mx-5" color="danger" variant="gradient" data-bs-dismiss="modal"
              style="width: 150px; height: 50px; padding-top: 15px" @click="close">
              {{ $t("button.close") }}
            </argon-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Fin Modal -->

  <!-- Guide Modal -->
  <div class="modal fade" id="guideModal" tabindex="-1" aria-labelledby="guideModalLabel" aria-hidden="true">
    <div class="modal-dialog glassmorphic-modal">
      <div class="modal-content">
        <div class="card">
          <div class="modal-header" style="border-bottom: 1px solid rgba(250,250,250,0.4);">
            <h5 class="modal-title" id="guideModalLabel">{{ $t("import_student_guide.title") }}</h5>
            <button type="button" @click="closeGuide" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" style="margin-top:20px; margin-bottom: 20px;">
            <p>{{ $t("import_student_guide.intro") }}</p>
            <div class="guide-steps">
              <div class="step">
                <h6>{{ $t("import_student_guide.step1_title") }}</h6>
                <p>{{ $t("import_student_guide.step1_text") }}</p>
              </div>
              <div class="step">
                <h6>{{ $t("import_student_guide.step2_title") }}</h6>
                <p>{{ $t("import_student_guide.step2_text") }}</p>
              </div>
              <div class="step">
                <h6>{{ $t("import_student_guide.step3_title") }}</h6>
                <p>{{ $t("import_student_guide.step3_text") }}</p>
                <ul>
                  <li>{{ $t("import_student_guide.columns.first_name") }}</li>
                  <li>{{ $t("import_student_guide.columns.last_name") }}</li>
                  <li>{{ $t("import_student_guide.columns.gender") }}</li>
                  <li>{{ $t("import_student_guide.columns.place_birth") }}</li>
                  <li>{{ $t("import_student_guide.columns.date_birth") }}</li>
                  <li>{{ $t("import_student_guide.columns.parent_phones") }}</li>
                </ul>
              </div>
              <div class="step">
                <h6>{{ $t("import_student_guide.step4_title") }}</h6>
                <p>{{ $t("import_student_guide.step4_text") }}</p>
              </div>
              <div class="step">
                <h6>{{ $t("import_student_guide.step5_title") }}</h6>
                <p>{{ $t("import_student_guide.step5_text") }}</p>
              </div>
              <p class="tip">{{ $t("import_student_guide.tip") }}</p>
            </div>
          </div>
          <div class="modal-footer" style="border-top: 1px solid rgba(250,250,250,0.5);">
            <argon-button type="button" class="btn mx-5" color="danger" variant="gradient" data-bs-dismiss="modal"
              style="width: 150px; height: 50px; padding-top: 15px" @click="closeGuide">
              {{ $t("button.close") }}
            </argon-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Fin Guide Modal -->

  <div class="p-4 container-fluid mt-6">
    <div class="row">
      <div class="left col-6">
        <div class="description mb-5">
          <p class="w-80 text-justify">
           {{ $t("import_student.top_text") }}
          </p>
          <argon-button data-bs-toggle="modal" class="px-5" data-bs-target="#exampleModal46" color="success" size="xl"
            style="background: #75acff; margin-top: 20px; height: 50px; padding-top:14px;">
            {{ $t("import_student.btn_model") }}
          </argon-button>
          <argon-button class="guide-btn px-3" data-bs-placement="top" :title="$t('import_student_guide.button_tooltip')" data-bs-target="#guideModal" data-bs-toggle="modal" color="info" size="xl"
            style="margin-top: 20px; height: 50px; padding-top:14px; margin-left: 10px;">
            <i class="fa fa-question-circle"></i>
          </argon-button>

        </div>
      </div>
    </div>
    <div class="custom-alert mt-4 mb-4" v-if="errorMessages.length">
      <ul>
        <li v-for="item in errorMessages" :key="item.line">
          <strong v-if="item.line">Line {{ item.line }}:</strong>
          <ul>
            <li v-for="(err, index) in item.errors" :key="index">{{ err }}</li>
          </ul>
        </li>
      </ul>
    </div>

    <drop-zone @change="selectedFile" @drop.prevent="drop"></drop-zone>
    <div class="title-info">
      <h6 v-if="dropzoneFile">
        <img :src="filePreviewRL" alt="" class="mx-1" height="50">
        <span class="heart-animation">{{ dropzoneFile.name }}</span>
      </h6>
      <h6 v-else>
        File:&nbsp; <span class="opacity-6">_ _ _ _ _ _ _ _ _ _ </span>
      </h6>
      <br />
      <span class="text-warning">{{ validFile }}</span>
    </div>
    <div v-if="isValidFile" id="import" ref="buttonsSection">
      <div class="import-student">
        <div class="row">
          <div class="col-lg-6">
            <argon-button click-event="" color="warning" @click="resetFile" full-width size="lg"
              style="height: 50px; padding-top: 14px; font-size: 15px">{{ $t("button.cancel") }}
            </argon-button>
          </div>
          <div class="col-lg-6">
            <argon-button :loading="loading" :active="buttonActive || showConfirmation" color="success" full-width
              size="lg" :clickEvent="button" @click="importStudent"
              style="height: 50px; padding-top: 14px; font-size: 15px">
                {{ $t("button.save") }}
            </argon-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import DropZone from "@/components/DropZone";
import { nextTick } from "vue";
import ArgonButton from "@/components/ArgonButton";
import {batchCreateStudent, uploadFile, getRegisterNumbersList} from "@/utils/services";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import * as XLSX from 'xlsx';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "import-student",
  components: { ArgonButton, DropZone },
  data() {
    return {
      button: "",
      loading: false,
      classroom_id: this.$route.params.classroomId,
      school_year: new Date().getFullYear(),
      buttonActive: false,
      showConfirmation: false,
      errorMessages: [],
      paymentType: '',
      count: '',
      isGenerating: false,
      show_generate: false,
      downloadLink: "",
      requiredFields: {
        count: false,
      },
      downloadFilename: "",
      fileURL: "",
      filePreviewRL: "",
      fileType: "",
      dropzoneFile: null,
      validFile: "",
      showGuideModal: false,
    };
  },
  computed: {
    isValidFile() {
      return this.fileType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    }
  },
  mounted() {
    this.loadPaymentType();
    this.$nextTick(() => {
      const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new window.bootstrap.Tooltip(tooltipTriggerEl);
      });
    });
  },
  methods: {
    
    close() {
      this.show_generate = false;
      this.downloadLink = false;
      document.body.classList.remove("modal-open");
      const modalBackdrops = document.getElementsByClassName("modal-backdrop");
      for (const backdrop of modalBackdrops) {
        backdrop.parentNode.removeChild(backdrop);
      }
    },

    closeGuide() {
      this.showGuideModal = false;
      this.close(); // Reuse the close logic
    },

    showgenerate() {
      this.show_generate = true;
    },

    loadPaymentType() {
      this.paymentType = localStorage.getItem('payment_type');
    },

    resetFile() {
      this.dropzoneFile = null;
      this.fileURL = "";
      this.fileType = "";
      this.validFile = "";
      window.location.reload();
    },

    scrollToButtons() {
      nextTick(() => {
        if (this.$refs.buttonsSection) {
          this.$refs.buttonsSection.scrollIntoView({ behavior: "smooth" });
        }
      });
    },

    async drop(e) {
      this.dropzoneFile = e.dataTransfer.files[0];
      this.fileType = this.dropzoneFile.type;
      if (!this.isValidFile) {
        this.validFile = "Le fichier doit être au format xlsx uniquement.";
      } else {
        this.validFile = "";
      }
      let res = await uploadFile(this.dropzoneFile);
      this.fileURL = res.url;
      this.filePreviewRL = res.preview;
      if (this.isValidFile) {
        this.scrollToButtons();
      }
    },

    async selectedFile() {
      const fileInput = document.querySelector(".dropzoneFile");
      if (!fileInput || !fileInput.files.length) {
        this.dropzoneFile = null;
        this.fileType = "";
        this.validFile = "No file selected.";
        return;
      }
      this.dropzoneFile = fileInput.files[0];
      this.fileType = this.dropzoneFile.type;

      if (!this.isValidFile) {
        this.validFile = "The file must be in xlsx format only.";
      } else {
        this.validFile = "";
      }

      let res = await uploadFile(this.dropzoneFile);
      //console.log(res)
      this.fileURL = res.url;
      this.filePreviewRL = res.preview;
      if (this.isValidFile) {
        this.scrollToButtons();
      }
    },

    async importStudent() {
      this.loading = true;
      this.button = "disabled";
      this.errorMessages = [];

      let data = {
        classroom_id: this.classroom_id,
        school_year: this.school_year,
        file: this.fileURL,
        payment_type: this.paymentType,
      };

      try {
        let res = await batchCreateStudent(data);

        if (res.data.errors && res.data.errors.length) {
          const groupedErrors = {};
          const globalErrors = [];

          res.data.errors.forEach(err => {
            const match = err.match(/on line (\d+)/);
            if (match) {
              const line = match[1];
              if (!groupedErrors[line]) groupedErrors[line] = [];
              const cleanedError = err.replace(/ on line \d+/, '');
              groupedErrors[line].push(cleanedError);
            } else {
              globalErrors.push(err);
            }
          });

          this.errorMessages = [
            ...Object.keys(groupedErrors).map(line => ({
              line,
              errors: groupedErrors[line]
            })),
            ...globalErrors.map(err => ({
              line: null,
              errors: [err]
            }))
          ];
        }

        if (res.status === 201) {
          this.errorMessages = [];
          if (!this.showConfirmation) {
            this.showConfirmation = true;
            toast.success("Students imported successfully!", { autoClose: 3000 });
            setTimeout(() => {
              this.showConfirmation = false;
              this.$router.push({
                name: "class-details",
                params: { classId: this.$route.params.classroomId },
              });
            }, 3000);
          }
        }
      } catch (error) {
        this.errorMessages = [];
        if (error.response && error.response.data && error.response.data.errors) {
          error.response.data.errors.forEach(err => {
            this.errorMessages.push({ line: null, errors: [err] });
          });
        } else {
          this.errorMessages.push({ line: null, errors: ["Error importing students. Please try again."] });
        }
      } finally {
        this.loading = false;
        this.button = "";
        this.buttonActive = false;
      }
    },


    async fetchAndDownloadRegistrationNumbers() {
      if (!this.count) {
        this.requiredFields.count = true;
        return;
      }
      this.isGenerating = true;
      try {
        const response = await getRegisterNumbersList(parseInt(this.count));
        if (response.error) {
          const message = this.$t("import_student.error_message");
          toast.error(message, {
            autoClose: 3000,
          });
        } else {
          console.log(response)
          this.generateExcelFile(response['registration_numbers']);
        }
      } catch (err) {
        this.error = "Error while get registration number.";
      } finally {
        this.isGenerating = false;
      }
    },

    // Header translations: [EN, FR]
    generateExcelFile(data) {
      const HEADER_MAP = {
        registration_number: ["Registration number", "Matricule"],
        first_name: ["First name", "Prénom"],
        last_name: ["Last name", "Nom"],
        gender: ["Gender", "Sexe"],
        pob: ["Place of birth", "Lieu de naissance"],
        dob: ["Date of birth", "Date de naissance"],
        parent_phones: ["Parent phones", "Téléphones parents"],
      };

      const locale = (this.$i18n && this.$i18n.locale) ? this.$i18n.locale : 'en';
      const isFr = locale.toString().startsWith('fr');

      const headers = [
        HEADER_MAP.registration_number[isFr ? 1 : 0],
        HEADER_MAP.first_name[isFr ? 1 : 0],
        HEADER_MAP.last_name[isFr ? 1 : 0],
        HEADER_MAP.gender[isFr ? 1 : 0],
        HEADER_MAP.pob[isFr ? 1 : 0],
        HEADER_MAP.dob[isFr ? 1 : 0],
        HEADER_MAP.parent_phones[isFr ? 1 : 0],
      ];

      // Normalize rows: if data is array of strings (registration numbers) => create empty rows
      let rows = [];
      if (Array.isArray(data) && data.length > 0 && typeof data[0] === 'string') {
        rows = data.map(num => [num, '', '', '', '', '', '']);
      } else if (Array.isArray(data) && data.length > 0 && typeof data[0] === 'object') {
        rows = data.map(item => [
          item.registration_number || '',
          item.first_name || '',
          item.last_name || '',
          item.gender || '',
          item.pob || '',
          item.dob || '',
          Array.isArray(item.parent_phones) ? item.parent_phones.join(',') : (item.parent_phones || ''),
        ]);
      } else {
        rows = [];
      }

      const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Registration Number");

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);

      // expose download link for UI and generate a locale-aware filename
      this.downloadLink = url;
      const fileCount = rows.length || 0;
      const filename = `students_${fileCount}_${locale}.xlsx`;
      this.downloadFilename = filename;

      // Revoke link after a short time to free memory
      setTimeout(() => {
        try { URL.revokeObjectURL(url); } catch (e) { console.warn('Failed to revoke object URL', e); }
        if (this.downloadLink === url) this.downloadLink = "";
        if (this.downloadFilename === filename) this.downloadFilename = "";
      }, 10000);
    },

    async generateSampleAndClose() {
      // generate 3 example rows client-side
      const sample = [
        { registration_number: 'SST2500092', first_name: 'Bernars', last_name: 'Martin', gender: 'M', pob: 'Foumban', dob: '01/02/2013', parent_phones: ['690198487','690198487','690198487'] },
        { registration_number: 'SST2500089', first_name: 'Leonardo', last_name: 'Junior', gender: 'M', pob: 'Yaounde', dob: '02/02/2012', parent_phones: ['690198488'] },
        { registration_number: 'SST2500081', first_name: 'Francois', last_name: 'Ibrahim', gender: 'M', pob: 'Douala', dob: '03/02/2011', parent_phones: ['690198489'] },
      ];
      this.generateExcelFile(sample);
      // immediately download the generated sample file (Non merci flow)
      this.downloadGeneratedFile();
      this.close();
    },
    
    downloadGeneratedFile() {
      if (!this.downloadLink) return;
      const a = document.createElement('a');
      a.href = this.downloadLink;
      a.download = this.downloadFilename || 'StudentSampleList.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
  },

  watch: {
    dropzoneFile(newFile) {
      if (newFile && this.isValidFile) {
        this.scrollToButtons();
      }
    }
  },

  created() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
};
</script>


<style lang="scss" scoped>
.title-info {
  margin-top: 32px;
}

.heart-animation {
  text-align: center;
  padding: 15px 5px;
  color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 0 0 rgba(71, 255, 138, 0.7);
  animation: battement 2s infinite cubic-bezier(.66, 0, 0, 1);
  text-decoration: none;
}

@keyframes battement {
  to {
    box-shadow: 0 0 0 30px rgba(255, 71, 84, 0);
  }
}

#import {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10vh;

  .import-student {
    width: 50%;
  }
}

.custom-alert {
  border: 1px solid #c45341;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.2);
  opacity: 0.8;
  color: #c45341;
  padding: 15px;
}

.custom-alert ul {
  list-style-type: none;
  padding: 0;
}

.custom-alert li {
  margin: 5px 0;
  padding-left: 20px;
  position: relative;

}

.generate-registration-number{
  height: 50px;
  width: 150px;
  border-radius: 0 10px 10px 0;
  padding: 0;
}

.required {
  border: 2px solid #f13939 !important;
  border-radius: 11px;
}

.generate {
  border: 1px solid rgba(250, 250, 250, 0.8);
  background: none;
  border-radius: 5px;
  height: 50px;
  width: 250px;
  transition: 0.3s;
  opacity: 0.8;
}

.generate:hover {
  transform: translateY(-2px)
}

.glassmorphic-modal {
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}

.guide-btn:hover {
  transform: scale(1.05);
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 123, 255, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(0, 123, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(0, 123, 255, 0);
  }
}

.guide-steps .step {
  margin-bottom: 20px;
}

.guide-steps .step h6 {
  color: #75acff;
  font-weight: 600;
}

.guide-steps .step ul {
  list-style-type: disc;
  margin-left: 20px;
}

.guide-steps .tip {
  font-style: italic;
  color: #6c757d;
  margin-top: 20px;
}
</style>
